import AppHeaderLinkButton from 'hb-react/shared/apps/PageCustomizables/components/AppHeaderLinkButton';
import type { User } from 'hb-react/types';

interface EventsHeaderControlsArgs {
  currentUser: (Pick<User, 'id'> & Partial<User>) | null;
  eventContentAvailable: boolean;
  isPreview?: boolean;
}

export const getEventsHeaderControls = ({
  currentUser,
  eventContentAvailable,
  isPreview = false,
}: EventsHeaderControlsArgs) => {
  const controls = [
    eventContentAvailable && currentUser && (
      <AppHeaderLinkButton
        url={Routes.user_new_user_event_path(currentUser.id, {
          context: 'events',
        })}
        label={s__('Events|Create new event')}
        isPreview={isPreview}
        target="_self"
      />
    ),
    currentUser && (
      <AppHeaderLinkButton
        url={Routes.user_my_events_path(currentUser.id)}
        label={s__('Events|Go to my events')}
        variant="secondary"
        isPreview={isPreview}
        target="_self"
      />
    ),
  ].filter(Boolean);

  return {
    controls,
  };
};
